import React from 'react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Tooltip } from '@mui/material';

export interface EtaIconProps {
  tooltipTitle: string;
}

function EtaIcon(props: EtaIconProps) {
  return (
    <Tooltip title={props.tooltipTitle} followCursor>
      <ReportProblemOutlinedIcon data-testid="eta-icon" fontSize="large" color="info" />
    </Tooltip>
  );
}

export default EtaIcon;
